<div class="AmLabel">
  <span class="text-am-grayblue-rebrand fs-18px lh-26px fw-medium-x">
    {{ label | translate }}
  </span>
  <span class="text-am-white fs-24px lh-34px fw-regular"
    [ngClass]="{ 'text-am-white-transp75': onlyValue }"
  >
    {{ value }}
  </span>
</div>